import Api from "../services/Api";
const api = Api.getInstance();

const shortMonth = [
  "jan",
  "feb",
  "mar",
  "apr",
  "maj",
  "jun",
  "jul",
  "aug",
  "sep",
  "okt",
  "nov",
  "dec"
];

export function formatDate(d: string, addMinutes?: number) {
  const now = new Date();
  if (!d) {
    return '-';
  }
  let date = parseDate(d);
  if (addMinutes) {
    date = new Date(date.getTime() + addMinutes * 60000);
  }

  const utcNow = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

  const dayDiff = Math.floor((utcDate - utcNow) / (24 * 3600 * 1000));

  let dayStr: string;
  if (dayDiff === 0) {
    dayStr = api.tr('today');
  } else if (dayDiff === 1) {
    dayStr = api.tr('list_view_walks');
  } else if (dayDiff === 2) {
    dayStr = "I övermorgon";
  } else if (dayDiff === -1) {
    dayStr = api.tr('yesterday')
  } else {
    if (now.getFullYear() === date.getFullYear()) {
      dayStr = date.getDate() + ' ' + shortMonth[date.getMonth()];
    } else {
      dayStr = date.getFullYear() + '-' + formatTwo(date.getMonth() + 1) + '-' + formatTwo(date.getDate());
    }
  }

  return dayStr + ' ' + formatTwo(date.getHours()) + ':' + formatTwo(date.getMinutes());
}

export function formatEnd(d: string, minutes: number) {
  if (d) {
    let date = parseDate(d);
    date = new Date(date.getTime() + minutes * 60000);
    return formatTwo(date.getHours()) + ':' + formatTwo(date.getMinutes());
  } else {
    return '';
  }
}

export function formatNow(addMonths: number, addMinutes?: number) {
  const d = new Date();
  let date: Date;
  if (addMonths !== 0) {
    date = new Date(d.setMonth(d.getMonth() + addMonths));
  } else if (addMinutes) {
    date = new Date(d.getTime() + addMinutes * 60000);
  } else {
    date = d;
  }
  let dayStr = date.getFullYear() + '-' + formatTwo(date.getMonth() + 1) + '-' + formatTwo(date.getDate());
  dayStr += 'T' + formatTwo(date.getHours()) + ':' + formatTwo(date.getMinutes());
  return dayStr;
}

export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return formatTwo(hours) + ':' + formatTwo(mins);
}

export function timeToMinutes(t: string): number {
  const timearr = t.split(':');
  return 60 * parseInt(timearr[0]) + parseInt(timearr[1]);
}

export function parseDate(d: string):Date {
  // d is format '2020-05-30 12:30' or '2020-05-30T12:30:00:23.823+02:00
  let separator: string = ' ';
  if (d.indexOf('T') > 0) {
    separator = 'T';
  }
  const arr = d.split(separator);
  const dateArr = arr[0].split('-');
  const timeArr = arr[1].split(':');
  const year = parseInt(dateArr[0]);
  const month = parseInt(dateArr[1]) - 1;
  const day = parseInt(dateArr[2]);
  const hour = parseInt(timeArr[0]);
  const minute = parseInt(timeArr[1]);
  return new Date(year, month, day, hour, minute);
}

export function formatYYYYMMDD(d: Date) {
  return d.getFullYear() + "-" + formatTwo(d.getMonth() + 1) + "-" + formatTwo(d.getDate())
}

export function formatYYYYMMDDT(d: Date) {
  return formatYYYYMMDD(d) + "T" + formatTwo(d.getHours())
      + ':' + formatTwo(d.getMinutes()) + ':' + formatTwo(d.getSeconds())
}

export function formatTime(d: Date) {
  return formatTwo(d.getHours()) + ':' + formatTwo(d.getMinutes()) + ':' + formatTwo(d.getSeconds())
}

export function formatTwo(nr: number) {
  if (nr < 10) {
    return '0' + nr;
  } else {
    return nr;
  }
}
